import Icon from '../components/Icon.vue'

Icon.register({
  'star-and-crescent': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M340.5 466.4c8.7 0 15.1 7 15.1 15.1 0 6.6-4.3 12.2-10.3 14.3-29 10.8-59.1 16.3-89.3 16.3-141.2 0-256-114.8-256-256s114.8-256 256-256c30.4 0 60.6 5.5 89.8 16.5 6.9 2.6 10.9 9.8 9.5 17.1-1.4 7-7.6 12.1-14.8 12.1-1.5 0-6.9-0.5-9.2-0.5-116.3 0-210.8 94.6-210.8 210.8s94.6 210.8 210.8 210.8c2.3 0 7.7-0.5 9.2-0.5zM503.5 213.9c8.2 1.2 11.4 11.2 5.5 17l-55.3 53.9 13 76.1c1.1 6.4-4 11.7-9.8 11.7-1.5 0-3.1-0.4-4.6-1.2l-68.3-35.9-68.3 35.9c-1.5 0.8-3.1 1.2-4.6 1.2-5.8 0-10.9-5.2-9.8-11.7l13-76.1-55.3-53.9c-5.9-5.8-2.7-15.8 5.5-17l76.4-11.1 34.2-69.2c1.8-3.7 5.4-5.5 8.9-5.5s7.1 1.8 8.9 5.5l34.2 69.2z'
      }
    ]
  }
})
